import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { Importacao } from '../core/_models'
import { importacoesColumns } from './columns/_columns'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const ImportacaoListTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => importacoesColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma importação encontrada'
      description={`Revise a ${t('empresa.label.lowercase')} ou o período selecionado.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma importação realizada'
      description='Use “Nova importação” para enviar a primeira planilha de atendimentos.'
    />
  )

  return (
    <CustomTable<Importacao>
      id='kt_table_importacoes'
      ariaLabel={t('importacao.plural')}
      itemLabel={{
        singular: t('importacao.label.lowercase'),
        plural: t('importacao.plural.lowercase'),
      }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
